import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useNotification } from '../../providers/notificationsProvider';
import { API_URL, getCachedSessionId } from '../../services/common';

const deleteCpanel = async ({ cpanelId, projectId, username }) => {
  const response = await axios.delete(
    `${API_URL}/v1/project/${projectId}/provider/hosting/cpanel/${cpanelId}`,
    {
      data: JSON.stringify({
        username
      }),
      headers: { 'Content-Type': 'application/json', 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const useDeleteCpanel = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();

  return useMutation(deleteCpanel, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['cPanel']);
      notify({ message: 'Cpanel was deleted successfully', severity: 'success' });
    }
  });
};
